import React from 'react';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { VISIT_MODES, type VisitMode } from './constants';

interface VisitModeSelectorProps {
  value: VisitMode;
  onChange: (value: VisitMode) => void;
}

const colorClasses = {
  blue: {
    selected: 'border-blue-500 bg-blue-50 text-blue-700',
    icon: 'text-blue-600',
  },
  green: {
    selected: 'border-green-500 bg-green-50 text-green-700',
    icon: 'text-green-600',
  },
  purple: {
    selected: 'border-purple-500 bg-purple-50 text-purple-700',
    icon: 'text-purple-600',
  },
} as const;

const VisitModeSelector: React.FC<VisitModeSelectorProps> = ({ value, onChange }) => {
  return (
    <div className='space-y-1.5'>
      <Label className='text-sm font-medium'>Visit Type</Label>
      <RadioGroup
        value={value}
        onValueChange={onChange}
        className='grid grid-cols-3 gap-2'
      >
        {VISIT_MODES.map(mode => {
          const Icon = mode.icon;
          const isSelected = value === mode.value;
          const colors = colorClasses[mode.color];

          return (
            <div key={mode.value}>
              <RadioGroupItem
                value={mode.value}
                id={`visit-mode-${mode.value}`}
                className='peer sr-only'
              />
              <Label
                htmlFor={`visit-mode-${mode.value}`}
                className={`flex cursor-pointer flex-col items-center rounded-lg border px-3 py-2.5 transition-all hover:border-gray-300 hover:bg-gray-50 ${
                  isSelected ? colors.selected : 'border-gray-200'
                }`}
              >
                <Icon
                  className={`mb-1 h-5 w-5 ${isSelected ? colors.icon : 'text-gray-400'}`}
                />
                <span className='text-xs font-medium'>{mode.label}</span>
              </Label>
            </div>
          );
        })}
      </RadioGroup>
    </div>
  );
};

export default VisitModeSelector;

